import React from 'react';
import PropTypes from 'prop-types';
import { CourseInfoContainer } from './QuizPageStyles.styles';
import InfoCard from '../../Components/InfoCard/InfoCard.component';

const QuizHeader = ({ courseName }) => {
  return (
    <>
      <CourseInfoContainer>
        <h2>{courseName} Quiz</h2>
      </CourseInfoContainer>
      <p className="disclaimer">
        Disclaimer: Although every effort is made to ensure the accuracy,
        currency and completeness of the information, We do not guarantee,
        warrant, represent or undertake that the information provided is
        correct, accurate or current. We are not liable for any loss, claim, or
        demand arising directly or indirectly from any use or reliance upon the
        information.
      </p>
      <div className="flexGap m1T">
        <InfoCard
          paragraph="To complete the course select one of the given answers for
                multiple choice or true or false. Once you have answered all the
                questions click on the Submit Quiz button. If you pass the quiz
                you will receive a certificate of completion. If you do not pass
                the quiz you can retake the quiz until you achieve the passing
                score. If you need to leave the page for any reason your quiz answers will be saved."
          span="You must have a score of 85% or higher to pass this course."
        />
      </div>
    </>
  );
};
QuizHeader.propTypes = {
  courseName: PropTypes.string.isRequired,
};
export default QuizHeader;
